import { RefObject, useEffect, useState } from 'react';
import { useTimeout } from '@mantine/hooks';

export function useScrollingState(ref: RefObject<HTMLElement | null>) {
  const [isScrolling, setScrolling] = useState(false);
  const { start, clear } = useTimeout(() => setScrolling(false), 100);
  useEffect(() => {
    function update() {
      setScrolling(true);
      clear();
      start();
    }
    const element = ref.current;
    if (element) {
      element.addEventListener('scroll', update);
      return () => element.removeEventListener('scroll', update);
    }
    return undefined;
  }, [ref, setScrolling, clear, start]);
  return isScrolling;
}
